import React, { useState } from 'react';
import { Modal, Box, Typography, Button, MenuItem, Select, FormControl, InputLabel, Backdrop, CircularProgress } from '@mui/material';

const FinishReviewModal = ({ open, onClose, onFinish, options }) => {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFinish = async () => {
    try {
      setLoading(true);
      await onFinish(selectedStatus);
    } finally {
      setLoading(false);
      onClose();
      setSelectedStatus('');
    }
  };

  const handleClose = () => {
    setSelectedStatus('')
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '8px',
      }}>

      <Backdrop
          sx={{ 
            color: '#fff', 
            zIndex: (theme) => theme.zIndex.modal + 1,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }}
          open={loading}
        >

          <CircularProgress color="inherit" />

      </Backdrop>

        <Typography variant="h6" component="h2" gutterBottom>
          Select Status
        </Typography>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="status-select-label">Status</InputLabel>
          <Select
            labelId="status-select-label"
            value={selectedStatus}
            label="Status"
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            {options.map((option) => (
              <MenuItem key={option.key} value={option.key}>
                {option.value} 
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', padding:2}}>
          <Button variant="contained" color="primary" onClick={handleFinish} disabled={!selectedStatus || loading}>
            Finish
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default FinishReviewModal;